import React, { useState } from "react";
import { Box, Typography, IconButton, Grid } from "@mui/material";
import { HighlightOff } from "@mui/icons-material";
import { getFileSize } from "../utils/file.js";
import UploadNewVersionButton from "./button/UploadNewVersionButton.js";
import ConfirmPopup from "./popup/ConfirmPopup.js";

const FileList = ({ files, onRemove, onUpdate, onUpload, showRemoveButton = true, type, onDownload, showCloudDownloadButton = true, disabled, accept }) => {
  const hasValidFiles = files && files.length > 0 && files.some((item) => item != null);
  const isDisabled = disabled || !hasValidFiles;
  const downloadDisabled = !hasValidFiles;

  const [confirmRemovePopup, setConfirmRemovePopup] = useState(false);
  const [removingItem, setRemovingItem] = useState(null);

  return (
    <>
      <Box display="flex" justifyContent="space-between" flexGrow={1} flexWrap="wrap">
        {files?.map((item, index) => (
          <Box key={index} borderBottom="1px solid #D0D5DE" flexGrow={1} display="flex" justifyContent="space-between" alignItems="center" py={0.5}>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <Box display="flex" gap={1}>
                  <img src="assets/icons/materials.svg" alt="materials" />
                  <Box>
                    <Typography sx={{ fontWeight: "bold" }}>{item?.filename}</Typography>
                    <Typography>{getFileSize(item?.fileSize)}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{item?.workset}</Typography>
              </Grid>
              <Grid item xs={2}>
                {onDownload && showCloudDownloadButton && (
                  <IconButton onClick={() => onDownload(item)} disabled={downloadDisabled}>
                    <img src={`assets/icons/${downloadDisabled ? "grey" : ""}clonedownload.svg`} alt="clonedownload" />
                  </IconButton>
                )}
                {showRemoveButton && (
                  <IconButton
                    onClick={() => {
                      setRemovingItem({ file: item, index });
                      setConfirmRemovePopup(true);
                    }}
                    disabled={isDisabled}
                  >
                    <HighlightOff sx={{ fontSize: 24 }} />
                  </IconButton>
                )}
              </Grid>
            </Grid>
            <UploadNewVersionButton onChange={(event) => onUpload(event, index, type)} disabled={isDisabled} accept={accept}></UploadNewVersionButton>
          </Box>
        ))}
      </Box>
      <ConfirmPopup
        open={confirmRemovePopup}
        message="Are you sure to remove the model from the project?"
        type="error"
        buttonLabelText="No"
        proceedButtonLabelText="Yes"
        iconSrc="assets/icons/error.svg"
        onCancel={() => {
          setConfirmRemovePopup(false);
          setRemovingItem(null);
        }}
        onConfirm={() => {
          if (removingItem) {
            onRemove(removingItem.file, removingItem.index);
          }
          setConfirmRemovePopup(false);
          setRemovingItem(null);
        }}
      ></ConfirmPopup>
    </>
  );
};

export default FileList;
